// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Praise him for his mighty acts;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;praise him according to his excellent greatness.<br> </p> </div></div>";
// Exports
module.exports = code;